import indicesOfSubstring from "../helpers/indicesOfSubstring";
import replaceAt from "../helpers/replaceAt";
import isEmpty from "../helpers/isEmpty";
//---------------------------
// capitalise multiple words
//---------------------------
export default function capitaliseMultipleWords(str) {
  // console.log("----------------------");
  // console.log("IN capitaliseMultipleWords = " + str);
  var return_str = "";

  if (!isEmpty(str)) {
    // locate any hyphens
    let hyphens = indicesOfSubstring(str, "-");
    // console.log("Hyphens = " + hyphens);

    // locate any apos
    let apos = indicesOfSubstring(str, "'");
    // console.log("Apos = " + apos);

    // locate any underscores
    let underscores = indicesOfSubstring(str, "_");
    // console.log("underscores = " + underscores);

    // split by space, hyphen or apos
    // let words = str.split(/[ -']/);
    const delims = / |-|'|_/

    // let words = str.split(" ").join("-").split("'").join("_");
    let words = str.split(delims);
    // console.log("words cnt = " + words.length)

    // words.forEach((a) => {
    //   console.log("word = " + a);
    // });

    // uppercase first letter of each word
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    // join words together
    return_str = words.join(" ");
    // console.log("CAP str before = " + return_str);

    // reapply any hyphens
    if (hyphens.length > 0) {
      return_str = replaceAt(return_str, hyphens, "-");
    }
    // reapply any apos
    if (apos.length > 0) {
      return_str = replaceAt(return_str, apos, "'");
    }
    // reapply any underscores
    if (underscores.length > 0) {
      return_str = replaceAt(return_str, underscores, "_");
    }
    // console.log("CAP str after = " + return_str);
    // console.log("----------------------");
  }
  return return_str;
}
